const collator = new Intl.Collator('pt-BR', {
  numeric: true,
  sensitivity: 'base',
});

// Raiz da fila: o que vem antes do primeiro "_" no nome do serviço
// (Demandas05_consult-pje → Demandas05). É a fila que o operador reconhece;
// a stack não serve, porque Demandas05 e Demandas012 dividem a mesma.
export function splitRoot(name: string): [string, string] {
  const i = name.indexOf('_');
  return i < 0 ? [name, ''] : [name.slice(0, i), name.slice(i + 1)];
}

// Compara a raiz da fila (antes do primeiro "_") e só então o resto: assim
// Leebrock_* vem inteiro antes de Leebrock2_*, que vem antes de Leebrock10_*,
// sem depender de onde cada motor põe o "_" em relação aos dígitos.
export function compareServiceNames(a: string, b: string): number {
  const [rootA, restA] = splitRoot(a);
  const [rootB, restB] = splitRoot(b);
  return (
    collator.compare(rootA, rootB) ||
    collator.compare(restA, restB) ||
    (a < b ? -1 : a > b ? 1 : 0)
  );
}
